import { Route, Routes, useParams } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Home from './screens/home';
import ServicePage from './screens/services/ServicePage';
import { getServices } from './screens/services/NewServices';
import { NavbarProvider, useNavbar } from './components/NavbarContext';
import FabricSubServicePage from './components/FabricSubService';
import ProjectGalleryPage from './screens/services/ProjectGalleryPage';
import { useTranslation } from 'react-i18next';

// This component handles finding and rendering the correct service
const ServiceRoute = () => {
  const { serviceId } = useParams<{ serviceId: string }>();
  const { t } = useTranslation();

  const services = getServices(t);
  const service = services.find(s => s.id === serviceId);

  if (!service) {
    return <div>Service not found</div>; // Or your 404 component
  }

  // Pass through all service properties exactly as they are in the configuration
  return <ServicePage
    {...service}
    primaryButtonActive={service.primaryButtonActive}
    secondaryButtonActive={service.secondaryButtonActive}
  />;
}

// Wrap the routes with the global click handler
const AppContent = () => {
  const { isMenuOpen, setIsMenuOpen } = useNavbar();

  const handleGlobalClick = () => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  };

return (
    <div onClick={handleGlobalClick}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services/:serviceId" element={<ServiceRoute />} />
        <Route path="/services/fabric/:slug" element={<FabricSubServicePage />} />
        <Route path="/services/:serviceType/:slug" element={<ProjectGalleryPage />} />
      </Routes>
    </div>
  );
};

const App = () => {
  return (
    <NavbarProvider>
      <AppContent />
    </NavbarProvider>
  );
};

export default App;